import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'
import { IDigitainState } from '../types'

import * as actions from '../actions'

export default combineReducers<IDigitainState['communications']>({
  getSportToken: makeCommunicationReducer(actions.getSportToken),
})
